import { useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import { getArticleById, articles } from '@/mocks/articles';
import { categoryColorMap, categories } from '@/mocks/categories';

export default function ArticlePage() {
  const { id } = useParams<{ id: string }>();
  const article = getArticleById(id || '');
  const catInfo = article ? categories.find((c) => c.slug === article.categorySlug) : null;
  const colors = catInfo ? categoryColorMap[catInfo.color] : categoryColorMap.primary;
  const relatedArticles = article
    ? articles.filter((a) => a.categorySlug === article.categorySlug && a.id !== article.id).slice(0, 3)
    : [];
  const hotComments = [
    { user: '吃瓜群众甲', avatar: 'https://readdy.ai/api/search-image?query=Chinese%20young%20person%20portrait%20avatar%20minimal%20style%20clean%20background%20warm%20tone&width=80&height=80&seq=cmt-avatar-01&orientation=squarish', content: '这也太劲爆了吧！没想到背后还有这么多不为人知的细节，吃瓜吃得我好撑。', date: '2026-07-07', likes: 1283 },
    { user: '八卦小王子', avatar: 'https://readdy.ai/api/search-image?query=Chinese%20young%20male%20portrait%20avatar%20minimal%20style%20clean%20background%20warm%20tone&width=80&height=80&seq=cmt-avatar-02&orientation=squarish', content: '早就觉得不对劲了，这次终于有人站出来爆料。坐等后续发展。', date: '2026-07-07', likes: 967 },
    { user: '理性吃瓜人', avatar: 'https://readdy.ai/api/search-image?query=Chinese%20young%20female%20casual%20portrait%20avatar%20minimal%20style%20clean%20background%20warm%20tone&width=80&height=80&seq=cmt-avatar-03&orientation=squarish', content: '大家先冷静一下，目前还没有官方回应，不要急着站队。让子弹再飞一会儿。', date: '2026-07-06', likes: 756 },
    { user: '深夜吃瓜党', avatar: 'https://readdy.ai/api/search-image?query=Chinese%20night%20owl%20person%20portrait%20avatar%20minimal%20style%20clean%20background%20warm%20tone&width=80&height=80&seq=cmt-avatar-04&orientation=squarish', content: '凌晨三点还在刷这个瓜，根本停不下来。明天上班怎么办？不管了，先吃完这个瓜再说。', date: '2026-07-06', likes: 632 },
    { user: '真相挖掘机', avatar: 'https://readdy.ai/api/search-image?query=Chinese%20investigator%20portrait%20avatar%20minimal%20style%20clean%20background%20warm%20tone&width=80&height=80&seq=cmt-avatar-05&orientation=squarish', content: '我补充一点：据我所知，这件事背后还涉及到一个更大的利益链条，不是表面看起来这么简单。', date: '2026-07-06', likes: 521 },
    { user: '吃瓜小透明', avatar: 'https://readdy.ai/api/search-image?query=Chinese%20shy%20person%20portrait%20avatar%20minimal%20style%20clean%20background%20warm%20tone&width=80&height=80&seq=cmt-avatar-06&orientation=squarish', content: '作为一个路人我只想说：这瓜保熟吗？不管了先吃为敬！', date: '2026-07-05', likes: 389 },
  ];

  useEffect(() => {
    if (article) {
      document.title = `${article.title} | 吃瓜网站线路一`;
    }
  }, [article]);

  if (!article) {
    return (
      <div className="min-h-screen bg-background-50">
        <Navbar />
        <div className="flex flex-col items-center justify-center min-h-[60vh] pt-16">
          <div className="w-20 h-20 flex items-center justify-center rounded-full bg-secondary-100 mb-6">
            <i className="ri-emotion-sad-line text-3xl text-foreground-400"></i>
          </div>
          <h1 className="font-heading text-2xl text-foreground-900 font-bold mb-2">文章未找到</h1>
          <p className="text-foreground-500 mb-6">很抱歉，您要查看的内容不存在或已被删除</p>
          <Link to="/" className="bg-primary-500 text-background-50 px-6 py-2.5 rounded-full text-sm font-medium hover:bg-primary-600 transition-colors duration-200 cursor-pointer whitespace-nowrap">
            返回首页
          </Link>
        </div>
        <Footer />
      </div>
    );
  }

  return (
    <>
      <script type="application/ld+json">
        {JSON.stringify({
          '@context': 'https://schema.org',
          '@type': 'Article',
          'headline': article.title,
          'description': article.summary,
          'author': { '@type': 'Person', 'name': article.author },
          'datePublished': article.publishDate,
          'image': article.imageUrl,
          'publisher': { '@type': 'Organization', 'name': '吃瓜网站线路一', 'url': 'http://91blw.cn/' },
        })}
      </script>
      <script type="application/ld+json">
        {JSON.stringify({
          '@context': 'https://schema.org',
          '@type': 'BreadcrumbList',
          'itemListElement': [
            { '@type': 'ListItem', 'position': 1, 'name': '首页', 'item': 'http://91blw.cn/' },
            { '@type': 'ListItem', 'position': 2, 'name': article.category, 'item': `http://91blw.cn/category/${article.categorySlug}` },
            { '@type': 'ListItem', 'position': 3, 'name': article.title, 'item': `http://91blw.cn/article/${article.id}` },
          ],
        })}
      </script>

      <div className="min-h-screen bg-background-50">
        <Navbar />

        {/* Breadcrumb */}
        <div className="bg-background-100 border-b border-background-200/70 pt-16">
          <div className="w-full px-4 md:px-6 py-3">
            <nav className="flex items-center gap-2 text-xs text-foreground-500 flex-wrap" aria-label="面包屑导航">
              <Link to="/" className="hover:text-primary-500 transition-colors duration-200 whitespace-nowrap">首页</Link>
              <i className="ri-arrow-right-s-line text-foreground-300"></i>
              <Link to={`/category/${article.categorySlug}`} className="hover:text-primary-500 transition-colors duration-200 whitespace-nowrap">{article.category}</Link>
              <i className="ri-arrow-right-s-line text-foreground-300"></i>
              <span className="text-foreground-800 font-medium line-clamp-1">{article.title}</span>
            </nav>
          </div>
        </div>

        <main>
          {/* Article Header */}
          <article className="py-8 md:py-12">
            <div className="w-full max-w-4xl mx-auto px-4 md:px-6">
              {/* Tags */}
              <div className="flex items-center gap-2 mb-6 flex-wrap">
                <Link
                  to={`/category/${article.categorySlug}`}
                  className={`inline-block px-4 py-1.5 rounded-full text-xs font-medium border ${colors.badgeText} border-current/30 whitespace-nowrap`}
                >
                  {article.category}
                </Link>
                {article.isExclusive && (
                  <span className="bg-accent-500 text-background-50 text-xs font-medium px-3 py-1.5 rounded-full whitespace-nowrap">独家爆料</span>
                )}
                {article.isHot && (
                  <span className="bg-primary-500 text-background-50 text-xs font-medium px-3 py-1.5 rounded-full whitespace-nowrap">
                    <i className="ri-fire-line mr-1"></i>热门
                  </span>
                )}
                {article.tags.map((tag) => (
                  <span key={tag} className="text-xs text-foreground-400 bg-background-100 px-3 py-1.5 rounded-full whitespace-nowrap">{tag}</span>
                ))}
              </div>

              {/* Title */}
              <h1 className="font-heading text-2xl md:text-4xl text-foreground-950 font-bold leading-tight mb-4">
                {article.title}
              </h1>

              {/* Meta */}
              <div className="flex flex-wrap items-center gap-4 text-sm text-foreground-500 mb-8">
                <div className="flex items-center gap-2">
                  <img src={article.authorAvatar} alt={article.author} className="w-7 h-7 rounded-full object-cover" />
                  <span className="font-medium text-foreground-700">{article.author}</span>
                </div>
                <span className="text-foreground-300">|</span>
                <span>{article.publishDate}</span>
                <span className="text-foreground-300">|</span>
                <span className="flex items-center gap-1">
                  <i className="ri-eye-line"></i> {article.readCount.toLocaleString()} 阅读
                </span>
                <span className="text-foreground-300">|</span>
                <span className="flex items-center gap-1">
                  <i className="ri-message-2-line"></i> {article.commentCount.toLocaleString()} 评论
                </span>
              </div>

              {/* Featured Image */}
              <div className="w-full rounded-2xl overflow-hidden mb-10">
                <img
                  src={article.imageUrl}
                  alt={article.title}
                  className="w-full h-auto object-cover"
                  title={article.title}
                />
              </div>

              {/* Article Content */}
              <div
                className="prose prose-lg max-w-none text-foreground-800 leading-relaxed"
                dangerouslySetInnerHTML={{ __html: article.content }}
              />
            </div>
          </article>

          {/* Hot Comments Section */}
          <section className="py-10 md:py-14 bg-secondary-50">
            <div className="w-full max-w-4xl mx-auto px-4 md:px-6">
              <div className="text-center mb-8">
                <div className="flex items-center justify-center gap-2 mb-3">
                  <span className="w-2 h-2 rounded-full bg-accent-500"></span>
                  <span className="text-xs text-foreground-400 tracking-wide">网友热议</span>
                </div>
                <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 font-bold">
                  网友热评
                </h2>
                <p className="text-sm text-foreground-500 mt-2">看看大家怎么说</p>
              </div>

              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
                {hotComments.map((comment, idx) => (
                  <div
                    key={idx}
                    className={`bg-background-50 rounded-lg p-5 ${idx === 5 ? 'opacity-50' : ''}`}
                  >
                    <div className="flex items-center gap-0.5 mb-3">
                      {[...Array(5)].map((_, i) => (
                        <i key={i} className="ri-star-fill text-accent-500 text-sm"></i>
                      ))}
                    </div>
                    <p className={`text-sm leading-relaxed mb-4 ${idx === 5 ? 'text-foreground-300' : 'text-foreground-600'}`}>
                      {comment.content}
                    </p>
                    <div className="flex items-center gap-3">
                      <img src={comment.avatar} alt={comment.user} className="w-8 h-8 rounded-full object-cover" />
                      <div>
                        <p className="text-sm font-medium text-foreground-800">{comment.user}</p>
                        <div className="flex items-center gap-2 text-xs text-foreground-400">
                          <span>{comment.date}</span>
                          <span className="flex items-center gap-0.5">
                            <i className="ri-thumb-up-line"></i> {comment.likes}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </section>

          {/* Related Articles */}
          {relatedArticles.length > 0 && (
            <section className="py-10 md:py-14 bg-background-50">
              <div className="w-full max-w-4xl mx-auto px-4 md:px-6">
                <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 font-bold mb-8 text-center">
                  相关追踪
                </h2>
                <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 md:gap-5">
                  {relatedArticles.map((rel) => (
                    <Link
                      key={rel.id}
                      to={`/article/${rel.id}`}
                      className="group cursor-pointer bg-background-100 rounded-xl overflow-hidden hover:bg-background-200/70 transition-all duration-300"
                    >
                      <div className="w-full h-36 overflow-hidden">
                        <img
                          src={rel.imageUrl}
                          alt={rel.title}
                          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                        />
                      </div>
                      <div className="p-4">
                        <h3 className="font-heading text-sm text-foreground-900 font-bold line-clamp-2 leading-snug group-hover:text-primary-500 transition-colors duration-200">
                          {rel.title}
                        </h3>
                        <p className="text-xs text-foreground-400 mt-2">{rel.publishDate}</p>
                      </div>
                    </Link>
                  ))}
                </div>
              </div>
            </section>
          )}

          {/* CTA */}
          <section className="py-10 md:py-14 bg-background-50">
            <div className="w-full max-w-xl mx-auto px-4 md:px-6 text-center">
              <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 font-bold mb-3">
                更多黑料爆料尽在 51 吃瓜
              </h2>
              <p className="text-sm text-foreground-500 mb-6">
                持续追踪最新动态，第一时间更新吃瓜内容
              </p>
              <Link
                to={`/category/${article.categorySlug}`}
                className="bg-primary-500 text-background-50 px-8 py-3 rounded-full text-sm font-medium hover:bg-primary-600 transition-all duration-300 cursor-pointer whitespace-nowrap inline-block"
              >
                查看更多{article.category} <i className="ri-arrow-right-line ml-2"></i>
              </Link>
            </div>
          </section>
        </main>

        <Footer />
      </div>
    </>
  );
}